<template>
  <v-app>
    <img class="logo" src="/logo.png" />
    <router-view />
    <vue-qr
      :dotScale="0.5"
      :margin="0"
      :size="150"
      :text="encodeURI(baseUrl + '#' + $route.path)"
      class="qr-code"
    />
  </v-app>
</template>

<script>
import VueQr from "vue-qr";
export default {
  components: { VueQr },
  data: () => ({
    baseUrl: location.protocol + "//" + location.host + "/"
  })
};
</script>

<style>
.home {
  margin: 0 auto;
  max-width: 450px;
  padding: 0 24px;
  width: 100%;
}
.konvajs-content {
  height: auto !important;
  position: initial !important;
  width: 100% !important;
}
.konvajs-content > canvas {
  height: auto !important;
  position: initial !important;
  width: 100% !important;
}
.logo {
  margin: 24px auto;
  width: 300px;
}
.qr-code {
  margin: 24px auto;
}
.search {
  margin: 0 auto;
  max-width: 600px;
  padding: 0 24px;
  width: 100%;
}
.theme--light.v-application {
  background: #fff;
}
</style>
